import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const StatusBubbleMarker = React.forwardRef(({ color, label, ...other }, ref) => (
  <Box
    ref={ref}
    {...other}
    sx={{
      width: 18,
      height: 18,
      borderRadius: '50%',
      bgcolor: color,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'default',
      userSelect: 'none',
      flexShrink: 0,
    }}
  >
    {label && (
      <Typography component="span" sx={{ fontWeight: 600, fontSize: 12, color: 'common.white' }}>
        {label}
      </Typography>
    )}
  </Box>
));

StatusBubbleMarker.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
};

StatusBubbleMarker.defaultProps = {
  color: null,
  label: null,
};

export default StatusBubbleMarker;
